import Vue from 'vue';
import { getVueI18n } from '../services/I18nService';

export function mountVueComponent (vueOptions, Component, props) {
  return new Vue({
    ...vueOptions,
    i18n: getVueI18n(),
    render: h => h(Component, { props })
  });
}
